import {faEye} from '@fortawesome/free-regular-svg-icons/faEye';
import {faEyeSlash} from '@fortawesome/free-regular-svg-icons/faEyeSlash';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import {useState} from 'react';

interface Props {
	fieldProps: object;
	error?: boolean;
	showPassword?: boolean;
	toggleShowPassword?: () => void;
}

export default function PasswordField({fieldProps, error = false, showPassword, toggleShowPassword}: Props) {
	const [show, setShow] = useState(false);

	const shouldShow = showPassword !== undefined ? showPassword : show;

	const toggle = () => {
		if (toggleShowPassword !== undefined) toggleShowPassword();
		else setShow((current) => !current);
	};

	return (
		<div className='relative w-full'>
			<div className='absolute inset-y-0 right-0 flex items-center px-4 md:px-3 lg:px-4'>
				<button type='button' className='text-sm text-gray-600 cursor-pointer' onClick={toggle}>
					<FontAwesomeIcon icon={shouldShow ? faEyeSlash : faEye} className='h-4 w-4 md:h-3 md:w-3 lg:h-6 lg:w-6' />
				</button>
			</div>
			<input
				{...fieldProps}
				placeholder='**********'
				className={clsx(
					'appearance-none w-full leading-tight bg-white text-auth-black/80 border border-black-80 rounded-lg py-3 pt-5 h-[56px] text-[16px]',
					{
						'border-red-400': error,
					},
					'focus:outline-none focus:border-primary',
				)}
				type={shouldShow ? 'text' : 'password'}
				autoComplete='off'
			/>
		</div>
	);
}
